import React from 'react';
import { Button, Text, HStack } from '@adc/parallax-component-library';
import i18n from '../../utilities/i18n';
import { Dialog } from 'tamagui';
import './Modal.scss';

type Props = {
  title: string;
  description: string;
  onConfirm: () => void;
  onCancel?: () => void;
  showCancelButton?: boolean;

  // Can be used to programmatically open the modal if no trigger is provided
  isOpen?: boolean;

  // If a trigger is not provided, then the modal must be opened via the isOpen prop
  trigger?: React.ReactNode;
};

export const ConfirmationModal = ({
  title,
  description,
  onConfirm,
  onCancel,
  showCancelButton = false,
  isOpen = false,
  trigger,
}: Props) => {
  return (
    <Dialog open={isOpen}>
      {trigger ? <Dialog.Trigger asChild>{trigger}</Dialog.Trigger> : null}
      <Dialog.Portal>
        <Dialog.Overlay key="overlay" />
        <Dialog.Content key="content" width="45%">
          <Dialog.Title>
            <Text type="$h3.strong">{title}</Text>
          </Dialog.Title>
          <Text paddingVertical="$2">{description}</Text>
          <HStack justifyContent="flex-end" gap="$2">
            {showCancelButton && onCancel ? (
              <Button
                variant="secondary"
                onPress={onCancel}
                label={i18n.t('Common.cancel')}
                testID="confirmation-modal-cancel-button"
              />
            ) : null}
            <Button
              variant="primary"
              onPress={onConfirm}
              label={i18n.t('Common.ok')}
              testID="confirmation-modal-confirm-button"
            />
          </HStack>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  );
};
